<template>
    <div>

        <p>
            Type
            <b-select v-model="type" :options="type_options" />
        </p>

        <!-- ── SIREN (lookup par colonne) ─────────────────────────────── -->
        <div v-if="type === 'siren'">
            <p>
                Colonne SIREN
                <b-input :list="'col_siren_' + id" v-model="column" />
                <datalist :id="'col_siren_' + id">
                    <option v-for="(c, i) in columns_data" :key="i">{{ c }}</option>
                </datalist>
            </p>
        </div>

        <!-- ── SIRET (lookup par colonne + filtres SIRENE) ────────────── -->
        <div v-if="type === 'siret'">
            <p>
                Colonne SIRET
                <b-input :list="'col_siret_' + id" v-model="column" />
                <datalist :id="'col_siret_' + id">
                    <option v-for="(c, i) in columns_data" :key="i">{{ c }}</option>
                </datalist>
            </p>
            <p>
                Filtres SIRENE (q=)
                <b-button style="padding:1px" variant="link" v-b-tooltip.hover
                    title="Syntaxe SIRENE ex: categorieEntreprise:ETI AND periodesUniteLegale.etatAdministratifUniteLegale:A">
                    <i class="fas fa-info"></i>
                </b-button>
                <a href="https://portail-api.insee.fr/catalog/api/2ba0e549-5587-3ef1-9082-99cd865de66f/doc?page=d5426723-2714-4385-8267-232714e385fe" target="_blank" class="ml-1">
                    <small>doc</small>
                </a>
                <b-input v-model="q" />
            </p>
            <p>
                Page
                <b-button style="padding:1px" variant="link" v-b-tooltip.hover
                    title="Laisser vide pour la première page, * pour curseur, ou nom d'une colonne">
                    <i class="fas fa-info"></i>
                </b-button>
                <b-input :list="'col_page_siret_' + id" v-model="page" placeholder="vide = page 1" />
                <datalist :id="'col_page_siret_' + id">
                    <option v-for="(c, i) in columns_data" :key="i">{{ c }}</option>
                </datalist>
            </p>
            <p>
                Résultats par page
                <b-input type="number" v-model.number="per_page" />
            </p>
        </div>

        <!-- ── SIREN SEARCH (query INSEE bulk) ───────────────────────── -->
        <div v-if="type === 'siren_search'">
            <p>
                Filtres SIRENE (q=)
                <b-button style="padding:1px" variant="link" v-b-tooltip.hover
                    title="Syntaxe SIRENE ex: categorieEntreprise:ETI AND trancheEffectifsUniteLegale:(32 OR 41)">
                    <i class="fas fa-info"></i>
                </b-button>
                <a href="https://portail-api.insee.fr/catalog/api/2ba0e549-5587-3ef1-9082-99cd865de66f/doc?page=d5426723-2714-4385-8267-232714e385fe" target="_blank" class="ml-1">
                    <small>doc</small>
                </a>
                <b-input v-model="q" />
            </p>
            <p>
                Page
                <b-button style="padding:1px" variant="link" v-b-tooltip.hover
                    title="Laisser vide pour la première page, * pour curseur automatique, ou nom d'une colonne">
                    <i class="fas fa-info"></i>
                </b-button>
                <b-input v-model="page" placeholder="vide = page 1  |  * = curseur automatique" />
            </p>
            <p>
                Résultats par page
                <b-input type="number" v-model.number="per_page" />
            </p>
        </div>

        <!-- ── RECHERCHE API ENTREPRISES (filtres query params) ───────── -->
        <div v-if="type === 'search_api'">
            <p>
                <b-checkbox v-model="no_file">
                    Exécuter sans fichier d'entrée
                    <b-button style="padding:1px" variant="link" v-b-tooltip.hover
                        title="Lance une requête unique sans CSV en entrée. Les valeurs des filtres sont fixes.">
                        <i class="fas fa-info"></i>
                    </b-button>
                </b-checkbox>
            </p>

            <p><strong>Filtres de recherche</strong></p>
            <table class="table table-sm table-bordered">
                <thead class="thead-light">
                    <tr>
                        <th style="width:44%">Paramètre</th>
                        <th>Valeur</th>
                        <th style="width:36px"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(f, i) in search_filters" :key="'sf_' + i">
                        <td>
                            <input
                                v-model="f.key"
                                class="form-control form-control-sm"
                                :list="'sa_keys_' + id"
                                placeholder="Tapez un paramètre…"
                                autocomplete="off"
                            />
                        </td>
                        <td>
                            <div class="d-flex align-items-start">
                                <b-button
                                    v-if="!no_file"
                                    size="sm"
                                    :variant="f.is_column ? 'info' : 'outline-secondary'"
                                    class="mr-1 flex-shrink-0"
                                    style="padding:2px 5px;font-size:10px"
                                    v-b-tooltip.hover
                                    :title="f.is_column ? 'Mode colonne : valeur issue du CSV' : 'Mode fixe : valeur statique'"
                                    @click="$set(f, 'is_column', !f.is_column)"
                                >col</b-button>
                                <div class="flex-grow-1">
                                    <b-input
                                        v-model="f.value"
                                        size="sm"
                                        :list="f.is_column && !no_file ? ('sa_cols_' + id + '_' + i) : undefined"
                                        :placeholder="f.is_column ? 'Nom de la colonne…' : (search_api_hints[f.key] || '')"
                                    />
                                    <datalist v-if="f.is_column && !no_file" :id="'sa_cols_' + id + '_' + i">
                                        <option v-for="(c, ci) in columns_data" :key="ci">{{ c }}</option>
                                    </datalist>
                                    <small v-if="!f.is_column && search_api_multi[f.key]" class="text-muted">
                                        Plusieurs valeurs : séparer par des virgules —
                                        <em>ex: {{ search_api_multi[f.key] }}</em>
                                    </small>
                                    <small v-else-if="!f.is_column && search_api_enum[f.key]" class="text-muted">
                                        Valeurs possibles :
                                        <span
                                            v-for="v in search_api_enum[f.key]"
                                            :key="v"
                                            class="badge badge-secondary mr-1 cursor-pointer"
                                            style="cursor:pointer"
                                            @click="f.value = f.value ? f.value + ',' + v : v"
                                        >{{ v }}</span>
                                    </small>
                                </div>
                            </div>
                        </td>
                        <td class="text-center align-middle">
                            <b-button size="sm" variant="outline-danger" @click="search_filters.splice(i, 1)">×</b-button>
                        </td>
                    </tr>
                    <tr v-if="search_filters.length === 0">
                        <td colspan="3" class="text-center text-muted"><small>Aucun filtre — cliquez sur + Filtre</small></td>
                    </tr>
                </tbody>
            </table>

            <!-- datalist pour l'autocomplete des clés -->
            <datalist :id="'sa_keys_' + id">
                <option v-for="p in search_api_param_options" :key="p.value" :value="p.value">{{ p.text }}</option>
            </datalist>

            <b-button size="sm" variant="outline-secondary" @click="search_filters.push({ key: '', value: '', is_column: false })">
                + Filtre
            </b-button>

            <hr />

            <p>
                <b-checkbox v-model="all_pages">Récupérer toutes les pages de résultats</b-checkbox>
            </p>
            <p v-if="!all_pages">
                Résultats par page <small class="text-muted">(max 25)</small>
                <b-input type="number" v-model.number="per_page" min="1" max="25" />
            </p>
            <p v-if="all_pages">
                Nombre de résultats max
                <b-button style="padding:1px" variant="link" v-b-tooltip.hover
                    title="Arrête la pagination après ce nombre total de résultats. Laisser 0 pour tout récupérer.">
                    <i class="fas fa-info"></i>
                </b-button>
                <b-input type="number" v-model.number="max_results" min="0" step="25" placeholder="0 = illimité" />
            </p>
        </div>

        <!-- ── OPTION GLOBALE ─────────────────────────────────────────── -->
        <hr />
        <p>
            <b-checkbox v-model="parse_result">
                Parser le JSON et créer une ligne par résultat
                <b-button style="padding:1px" variant="link" v-b-tooltip.hover
                    title="Chaque entreprise du tableau 'results' devient une ligne dans le CSV, avec toutes ses colonnes à plat">
                    <i class="fas fa-info"></i>
                </b-button>
            </b-checkbox>
        </p>

    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";

    export default {
        name: "siren",
        components: {},
        props: {
            treatment_params: { default: false },
            files:            { default: () => [] },
            data:             { default: () => [] },
            client:           { default: null },
            size:             { default: 1000 },
            step_position:    { default: 0 }
        },

        watch: {
            data: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.data.length > 0)
                        this.columns_data = Object.keys(this.data[0]);
                }
            },
            files: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.files.length > 0) {
                        var self = this;
                        var reader = new FileReader();
                        reader.onload = (function(theFile) {
                            return function(e) {
                                if (e.target.result) {
                                    var parsed = self.$papa.parse(e.target.result, { header: true });
                                    if (parsed.data && parsed.data.length > 0)
                                        self.columns_data = Object.keys(parsed.data[0]);
                                }
                            };
                        })(this.files[0].file ? this.files[0].file : this.files[0]);
                        reader.readAsText(this.files[0].file ? this.files[0].file : this.files[0]);
                    }
                }
            }
        },

        data() {
            return {
                id: uniqueId("siren_"),

                // commun
                type:     "siren",
                column:   "",
                q:        "",
                page:     "",
                per_page: 10,
                ms:       500,

                // search_api
                search_filters: [],
                all_pages:      false,
                no_file:        false,
                max_results:    0,

                // global
                parse_result: false,

                columns_data: [],

                // ── configuration UI ────────────────────────────────────
                type_options: [
                    { text: "Chercher une entreprise par numéro SIREN — Annuaire des Entreprises (data.gouv.fr)",      value: "siren" },
                    { text: "Chercher un établissement par numéro SIRET — Base SIRENE (INSEE)",                        value: "siret" },
                    { text: "Chercher des entreprises par critères — Base SIRENE (INSEE)",                             value: "siren_search" },
                    { text: "Chercher des entreprises par filtres avancés — Annuaire des Entreprises (data.gouv.fr)",  value: "search_api" },
                ],

                filters_libre_keys: [],
                filters_libre_labels: {},
                filters_libre: {},

                search_api_param_options: [
                    { value: "q",                              text: "q — recherche textuelle (nom, adresse, dirigeant, SIREN…)" },
                    { value: "categorie_entreprise",           text: "categorie_entreprise — PME, ETI, GE" },
                    { value: "etat_administratif",             text: "etat_administratif — A (active), C (cessée)" },
                    { value: "tranche_effectif_salarie",       text: "tranche_effectif_salarie — ex: 32,41,42,51" },
                    { value: "activite_principale",            text: "activite_principale — code NAF ex: 62.01Z" },
                    { value: "section_activite_principale",    text: "section_activite_principale — ex: J,M" },
                    { value: "nature_juridique",               text: "nature_juridique — ex: 5710,5720" },
                    { value: "departement",                    text: "departement — ex: 75,69" },
                    { value: "region",                         text: "region — ex: 11,84" },
                    { value: "code_postal",                    text: "code_postal — ex: 75001,69001" },
                    { value: "code_commune",                   text: "code_commune — ex: 75056" },
                    { value: "est_ess",                        text: "est_ess — true/false" },
                    { value: "est_association",                text: "est_association — true/false" },
                    { value: "est_entrepreneur_individuel",    text: "est_entrepreneur_individuel — true/false" },
                    { value: "est_rge",                        text: "est_rge — true/false" },
                    { value: "est_qualiopi",                   text: "est_qualiopi — true/false" },
                    { value: "est_organisme_formation",        text: "est_organisme_formation — true/false" },
                    { value: "est_finess",                     text: "est_finess — true/false" },
                    { value: "est_siae",                       text: "est_siae — true/false" },
                    { value: "est_administration",             text: "est_administration — true/false" },
                    { value: "est_societe_mission",            text: "est_societe_mission — true/false" },
                    { value: "est_bio",                        text: "est_bio — true/false" },
                    { value: "est_uai",                        text: "est_uai — true/false" },
                    { value: "est_patrimoine_vivant",          text: "est_patrimoine_vivant — true/false" },
                    { value: "egapro_renseignee",              text: "egapro_renseignee — true/false" },
                    { value: "convention_collective_renseignee", text: "convention_collective_renseignee — true/false" },
                ],

                search_api_hints: {
                    categorie_entreprise:           "PME, ETI ou GE",
                    etat_administratif:             "A ou C",
                    tranche_effectif_salarie:       "ex: 32,41,42,51",
                    activite_principale:            "ex: 62.01Z,70.22Z",
                    section_activite_principale:    "ex: J,M,N",
                    nature_juridique:               "ex: 5710,5720",
                    departement:                    "ex: 75,69,13",
                    region:                         "ex: 11,84",
                    code_postal:                    "ex: 75001,69001",
                    code_commune:                   "ex: 75056",
                },

                // paramètres qui acceptent plusieurs valeurs séparées par virgules
                search_api_multi: {
                    tranche_effectif_salarie:    "32,41,42,51  (équivalent à OR entre les valeurs)",
                    activite_principale:         "62.01Z,70.22Z",
                    section_activite_principale: "J,M,N",
                    nature_juridique:            "5710,5720",
                    departement:                 "75,69,13",
                    region:                      "11,84",
                    code_postal:                 "75001,69001",
                    code_commune:                "75056,69123",
                },

                // paramètres à valeurs fixes (badges cliquables)
                search_api_enum: {
                    categorie_entreprise:  ["PME", "ETI", "GE"],
                    etat_administratif:    ["A", "C"],
                    est_ess:               ["true", "false"],
                    est_association:       ["true", "false"],
                    est_entrepreneur_individuel: ["true", "false"],
                    est_rge:               ["true", "false"],
                    est_qualiopi:          ["true", "false"],
                    est_organisme_formation: ["true", "false"],
                    est_finess:            ["true", "false"],
                    est_siae:              ["true", "false"],
                    est_administration:    ["true", "false"],
                    est_societe_mission:   ["true", "false"],
                    est_bio:               ["true", "false"],
                    est_uai:               ["true", "false"],
                    est_patrimoine_vivant: ["true", "false"],
                    egapro_renseignee:     ["true", "false"],
                    convention_collective_renseignee: ["true", "false"],
                },
            };
        },

        methods: {
            get_data() {
                return this.save();
            },

            save() {
                var data = {
                    type:     this.type,
                    ms:       this.ms,
                    per_page: this.per_page,
                };

                if (this.type === "siren") {
                    data.column = this.column;
                }
                else if (this.type === "siret") {
                    data.column   = this.column;
                    data.q        = this.q;
                    data.page     = this.page;
                }
                else if (this.type === "siren_search") {
                    data.q    = this.q;
                    data.page = this.page;
                }
                else if (this.type === "search_api") {
                    data.filters     = this.search_filters.filter(f => f.key && f.value !== "");
                    data.all_pages   = this.all_pages;
                    data.per_page    = this.all_pages ? 25 : this.per_page;
                    data.no_file     = this.no_file;
                    data.max_results = this.max_results || 0;
                }

                data.parse_result = this.parse_result;

                return data;
            },

            load(data) {
                if (!data) return;

                this.type     = data.type     || "siren";
                this.ms       = data.ms       || 500;
                this.per_page = data.per_page || 10;
                this.column   = data.column   || "";
                this.q        = data.q        || "";
                this.page     = data.page     || "";
                this.all_pages    = data.all_pages    || false;
                this.no_file      = data.no_file      || false;
                this.max_results  = data.max_results  || 0;
                this.parse_result = data.parse_result || false;

                // search_api
                if (data.filters && this.type === "search_api") {
                    this.search_filters = Array.isArray(data.filters) ? [...data.filters] : [];
                }
            },
        },

        async mounted() {}
    }
</script>

<style scoped>
table td, table th {
    vertical-align: middle;
}
</style>
